import React, { useState } from "react";
import {
  Grid,
  GridNoRecords,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import { EditCommandCell } from "../../pages/Settings/GridComponents";
import { GridLoader } from "components/GridLoader";
import { toast } from "react-toastify";

const List = ({
  editAction,
  editFormComponent: EditFormComponent,
  columns,
  component,
  gridData: externalGridData,
  loading: externalLoading,
  ...props
}) => {
  const [openForm, setOpenForm] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const data = externalGridData ?? [];
  const loading = externalLoading ?? false;

  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem(item);
  };

  const handleSubmit = async (event) => {
    try {
      const id =
        event.activityTypeID ?? event.activityTagID ?? event?.timeTypeID ?? event?.tagId ?? event?.ledgerCardSettingId ?? event?.id;

      const allowedComponents = ["timeTypes", "activityTypes", "activityTags", "ledgerCardSettings"];
      if (!allowedComponents.includes(component)) {
        return;
      }
      const result = await editAction(id, event);
      if (result.success) {
        const successMessages = {
          timeTypes: `Time Type '${event?.name}' has been updated.`,
          activityTypes: "Activity Type Updated successfully",
          activityTags: `Activity Tag '${event?.name}' updated successfully`,
          ledgerCardSettings: `Ledger Card Setting '${event?.postingName}' updated successfully`,
        };
        toast.success(successMessages[component]);
        setOpenForm(false);
      }
    } catch (error) { }
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  return (
    <div className="h-100">
      <div className="settings-grid h-100">
        <Grid
          data={data}
          showLoader={loading}
          style={{ height: "100%", width: "max-content", maxWidth: "100%" }}
          loader={
            <div style={{ minHeight: "50vh" }}>
              <GridLoader />
            </div>
          }>
          <GridNoRecords>
            {loading ? (
              <span></span>
            ) : (
              data && data?.length === 0 && "No records available"
            )}
          </GridNoRecords>
          {columns.map((column, index) => (
            <Column key={index} {...column} />
          ))}
          <Column title=" " cell={MyEditCommandCell} width="60" />
        </Grid>
      </div>

      {openForm && (
        <EditFormComponent
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
        />
      )}
    </div>
  );
};

export default List;
